import { Component, OnInit, EventEmitter, Output, ChangeDetectorRef } from '@angular/core';
import { UserManagementService } from 'app/services/user-management.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'app/services/data.service';
import { Location } from '@angular/common';
import { FrontEndService } from "../../services/front-end.service";
import { LogService } from "app/services/log.service";
import { StateService } from '@uirouter/angular';

@Component({
    selector: 'app-create-user',
    templateUrl: './create-user.component.html',
    styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
    name_error = false;
    title_error = false;
    username_error = false;
    role_error = false;
    password_error = false;
    confirm_password_error = false;
    mobile_number_error = false;
    password = "";
    confirm_password = "";
    name = "";
    title = "";
    username = "";
    mobile_number = "";
    role = "";
    errorMessage = "";
    closeResult: string;
    just_registered_user_id: any;
    fullScreenLoader = false;

    @Output() closeEvent = new EventEmitter<string>();
    @Output() sendUserId = new EventEmitter();

    // On error, Focus variables
    public name_focus = new EventEmitter<boolean>();
    public username_focus = new EventEmitter<boolean>();
    public role_focus = new EventEmitter<boolean>();

    constructor(
        private user_management_service: UserManagementService,
        private modalService: NgbModal,
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private _location: Location,
        private translate:TranslateService,
        private stateService: StateService,
        private logService: LogService,
        private cdr: ChangeDetectorRef
    ) { }

    callParent() {
       this.closeEvent.next('somePhone');
    }

    ngOnInit() {
    }

    setUserRole(user_id, role_id) {
        this.fullScreenLoader = true;
        this.user_management_service.userRole(role_id, user_id, (resp) => {
            this.fullScreenLoader = false;
            if(resp.status === true) {
                this.front_end_service.addToast("Success", "user_created_successfully", "success");

                // Send result back to parent component
                this.sendUserId.emit(user_id);

                if(this.front_end_service.show_header) {
                    this.front_end_service.back();
                } else {
                    this.callParent();
                }
            }
        })
    }

    activateUser(is_verified, user_id) {
        this.fullScreenLoader = true;
        this.logService.printLog("Activate user reached");
        this.user_management_service.userVerified(is_verified, user_id, (resp) => {
            if(resp.status === true) {
                this.setUserRole(this.just_registered_user_id, this.role)
            } else {
                this.fullScreenLoader = false;
            }
        });
    }

    onSubmit(user) {
        const regEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const regPassword = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])(?=.*[a-z])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
        this.logService.printLog("user" + JSON.stringify(user));
        if (user['name'].trim() === "" || user['name'] === undefined) {
            this.hide_all_errors();
            this.name_error = true;
            this.name_focus.emit(true);
            this.errorMessage = 'enter_your_name';
        } else if( user['username'].trim() === "" || user['username'] === undefined) {
            this.hide_all_errors();
            this.username_error = true;
            this.username_focus.emit(true);
            this.errorMessage = 'enter_an_email_id';
        } else if( !regEmail.test(user.username)) {
            this.hide_all_errors();
            this.username_error = true;
            this.username_focus.emit(true);
            this.errorMessage = 'enter_a_valid_email_id';
        } else if( user.role === "" || user.role === undefined) {
            this.hide_all_errors();
            this.role_error = true;
            this.role_focus.emit(true);
            this.errorMessage = 'select_a_role';
        } else {
            this.hide_all_errors();
            user['title'] = this.title;
            if(user['title'] == 'null') {
               user['title'] = ''
            }
            user['role'] = this.role;
            this.fullScreenLoader = true;
            this.user_management_service.createUserProfile(user, (resp) => {
                if(resp.status === true) {
                    const is_verified = true;
                    this.just_registered_user_id = resp.data.id;
                    // setUserRole is called from Activate User. Keep it that way to reduce more complexity in screen navigation.
                    this.activateUser(is_verified, this.just_registered_user_id);
                } else {
                    this.fullScreenLoader = false;
                }
            })
        }
    }

    hide_all_errors() {
        this.username_error = false;
        this.title_error = false;
        this.name_error = false;
        this.role_error = false;
        this.password_error = false;
        this.confirm_password_error = false;
        this.mobile_number_error = false;
    }

    roleChanged = (event) => {
        this.role = event.value;
        this.cdr.detectChanges();
    };

    cancel() {
        if(this.front_end_service.show_header) {
            this.front_end_service.back();
        } else {
            this.callParent()
        }
    }
}
